import Moment from 'moment'
import {i18n} from '~/plugins/i18n'
import {deviceDataTreeConvert} from '~/utils/device-common'
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'

function initSysTreeOpt () {
  return {
    only_group_yn: 0, // 그룹만 로딩할지 여부(0= No 1= Yes)
    tams_yn: 1, // TAMS 표현 여부(0= No 1= Yes)
    slave_yn: 1, // SLAVE 표현 여부(0= No 1= Yes)
    only_config_yn: 0, // 설정 장비만 표현 여부 (0= No 1= Yes)
    tree_type: 0, // 트리 타입(0=기본트리 1=메뉴별 장비트리)
    only_policy_mng_yn: 0, // 대상 방화벽만 출력할지 여부(PAMS 전용) (0= No 1= Yes)
    only_tams_yn: 0 // TAMS 장비만 표현 여부 (0=No 1=Yes)
  }
}

function initMenuOpt () {
  return {
    only_group_yn: 0, // 그룹만 로딩할지 여부(0= No 1= Yes)
    tams_yn: 0, // TAMS 표현 여부(0= No 1= Yes)
    slave_yn: 0, // SLAVE 표현 여부(0= No 1= Yes)
    only_config_yn: 1, // 설정 장비만 표현 여부 (0= No 1= Yes)
    tree_type: 1, // 트리 타입(0=기본트리 1=메뉴별 장비트리)
    menu_id: null, // 메뉴ID
    target_id_val: 0, // 해당 메뉴의 device테이블 id(***_cm_id)값 담아 호출
    only_policy_mng_yn: 0 // 대상 방화벽만 출력할지 여부(PAMS 전용) (0= No 1= Yes)
  }
}

function initDefaultMenuOpt () {
  return {
    only_group_yn: 0, // 전체 로딩
    tams_yn: 0, // TAMS 미포함
    slave_yn: 0, // SLAVE 미포함
    only_config_yn: 1, // 설정 장비만 표현 여부 (0= No 1= Yes)
    tree_type: 1, // 기본 트리
    only_policy_mng_yn: 0 // 대상 방화벽만 출력할지 여부(PAMS 전용) (0= No 1= Yes)
  }
}

function initModeClassName () {
  return {
    A: 'ps-q-btn-tree-add',
    M: 'ps-q-btn-tree-select',
    D: 'ps-q-btn-tree-delete',
    W: 'ps-q-btn-tree-memo'
  }
}

function initSelectedMemo () {
  return {
    device_id: 0,
    device_memo_id: 0,
    cfg_dt: Moment().format(DATE_FORMAT),
    // cfg_dt: '',
    device_memo_cntnt: ''
  }
}

function initOverDeviceInfo () {
  return {
    code: 0,
    msg: '',
    addr: null,
    device_force_add_yn: 0,
    device_force_add_tams_type: 0
  }
}

export const state = () => ({
  filterType: false,
  memoUse: false,
  sysTreeUse: false,
  configOnly: false,
  sysTreeOpt: initSysTreeOpt(),
  // 장치관리 리스트
  devicesTreeUrl: `${apiPrefix}/devices-tree`, // TAMS 미출력
  // devicesTreeUrl: `${apiPrefix}/devices-tree-by-menu`,
  menuOpt: initMenuOpt(),
  defaultMenuOpt: initDefaultMenuOpt(),
  sysDevicesTreeUrl: `${apiPrefix}/system-devices-tree`, // TAMS 출력
  devicesUrl: `${apiPrefix}/devices`,
  devicesMemoUrl: `${apiPrefix}/device-memo`,
  orgDeviceTreeData: [],
  deviceParent: [],
  deviceDataAll: [], // 그룹(0, 4) 제외한 장비 정보(key: device_id 값)
  deviceTreeData: [],
  deviceExpanded: [],
  device_id: 0,
  deviceMemoList: [],
  // deviceMemo: {},
  selectedMemo: initSelectedMemo(),
  modeClassName: initModeClassName(),
  // 장비 덮어 쓰기
  overDeviceInfo: initOverDeviceInfo()
})

export const mutations = {
  // TAMS
  initAllDeviceTreeState (state) {
    state.filterType = false
    state.memoUse = false
    state.sysTreeUse = false
    state.configOnly = false
    state.sysTreeOpt = initSysTreeOpt()

    state.menuOpt = initMenuOpt()
    state.defaultMenuOpt = initDefaultMenuOpt()
    state.orgDeviceTreeData = []
    state.deviceParent = []
    state.deviceDataAll = [] // 그룹(0, 4) 제외한 장비 정보(key: device_id 값)
    state.deviceTreeData = []
    state.deviceExpanded = []
    state.device_id = 0
    state.deviceMemoList = []

    state.selectedMemo = initSelectedMemo()
    state.modeClassName = initModeClassName()
    // 장비 덮어 쓰기
    state.overDeviceInfo = initOverDeviceInfo()
  },
  initMenuOpt (state) {
    state.menuOpt = _.cloneDeep(state.defaultMenuOpt)
  },
  // Tree Option 적용.
  // ### System 트리
  // # sysTreeUse: true > sysTree: true 만 설정시
  // # ---> only_group_yn=0, tams_yn=1, slave_yn=1, only_config_yn=1, tree_type=0
  // ### CM 트리 (메뉴별 트리)
  // # sysTreeUse: false > sysTree: false 만 설정시
  // # ---> only_group_yn=0, tams_yn=0, slave_yn=0, only_config_yn=0, tree_type=1, menu_id={menu_id}, target_id_val=0 or {cm_id}
  setMenuOpt (state, data = {}) {
    // Default Group : 0 - 전체
    state.menuOpt.only_group_yn = _.has(data, 'only_group_yn') ? data.only_group_yn : 0
    state.sysTreeOpt.only_group_yn = _.has(data, 'only_group_yn') ? data.only_group_yn : 0
    // Default TAMS : 0 - TAMS 미포함
    state.menuOpt.tams_yn = _.has(data, 'tams_yn') ? data.tams_yn : 0
    state.sysTreeOpt.tams_yn = _.has(data, 'tams_yn') ? data.tams_yn : 1
    // Default SLAVE : 1 - SLAVE 포함
    state.menuOpt.slave_yn = _.has(data, 'slave_yn') ? data.slave_yn : 0
    state.sysTreeOpt.slave_yn = _.has(data, 'slave_yn') ? data.slave_yn : 1
    // Default Config : 0 - 전체
    // tree_type: 1 일때 only_config_yn 값을 설정 안하면 1로 설정됨.
    // tree_type: 2 일때 only_config_yn 값을 설정 안하면 0로 설정됨.
    state.menuOpt.only_config_yn = _.has(data, 'only_config_yn') ? data.only_config_yn : 1
    state.sysTreeOpt.only_config_yn = _.has(data, 'only_config_yn') ? data.only_config_yn : 0
    if (_.has(data, 'except_mon_node_yn')) {
      state.menuOpt.except_mon_node_yn = data.except_mon_node_yn
      state.sysTreeOpt.except_mon_node_yn = data.except_mon_node_yn
    } else {
      delete state.menuOpt.except_mon_node_yn
      delete state.sysTreeOpt.except_mon_node_yn
    }
    // Default Tree : 0 - 기본 트리
    state.menuOpt.tree_type = _.has(data, 'tree_type') ? data.tree_type : 1
    state.sysTreeOpt.tree_type = 0 // System Tree는 Tree Type 무조건 0
    // Tree 가 메뉴 트리 일 경우 menu_id, target_id_val 반드시 필요.
    if (state.menuOpt.tree_type === 1) {
    // state.menuOpt.only_config_yn = 1
      state.menuOpt.menu_id = _.has(data, 'menu_id') ? data.menu_id : this.getters['common/multirw/thisMenu'].code
      if (_.has(data, 'menu_sub_id')) {
        state.menuOpt.menu_id = Number(`${state.menuOpt.menu_id}${data.menu_sub_id}`)
      }
      state.menuOpt.target_id_val = _.has(data, 'target_id_val') ? data.target_id_val : 0 // 신규 등록
    // Tree 가 기본 트리 일 경우 menu_id, target_id_val 삭제
    } else {
      delete state.menuOpt.menu_id
      delete state.menuOpt.target_id_val
    }
    // Default PAMS 대상방화벽 조회 : 0 - 모든 장비, 1 - 대상방화벽만 조회
    state.menuOpt.only_policy_mng_yn = _.has(data, 'only_policy_mng_yn') ? data.only_policy_mng_yn : 0
    state.sysTreeOpt.only_policy_mng_yn = _.has(data, 'only_policy_mng_yn') ? data.only_policy_mng_yn : 0
    // 1. menu option 값이 있을 경우 적용.
    // if (_.has(data, 'device_model_type')) {
    //   state.menuOpt.device_model_type = data.device_model_type
    //   state.sysTreeOpt.device_model_type = data.device_model_type
    // }
  },
  setDeviceId (state, data) {
    state.device_id = data
  },
  setFilterType (state, data) {
    state.filterType = data
  },
  setMemoUse (state, data) {
    state.memoUse = data
  },
  setSysTreeUse (state, data) {
    state.sysTreeUse = data
  },
  setOnlyConfig (state, data) {
    if (state.sysTreeOpt) {
      state.sysTreeOpt.only_config_yn = data ? 1 : 0
    }
  },
  setOnlyGroup (state, data) {
    if (state.menuOpt) {
      state.menuOpt.only_group_yn = data ? 1 : 0
    }
    if (state.sysTreeOpt) {
      state.sysTreeOpt.only_group_yn = data ? 1 : 0
    }
  },
  setTams (state, data) {
    if (state.sysTreeOpt) {
      state.sysTreeOpt.tams_yn = data ? 1 : 0
    }
  },
  setSlave (state, data) {
    if (state.sysTreeOpt) {
      state.sysTreeOpt.slave_yn = data ? 1 : 0
    }
  },
  setOnlyTams (state, data) {
    if (state.sysTreeOpt) {
      state.sysTreeOpt.only_tams_yn = data ? 1 : 0
    }
  },
  setOnlyPolicyMng (state, data) {
    if (state.menuOpt) {
      state.menuOpt.only_policy_mng_yn = data ? 1 : 0
    }
    if (state.sysTreeOpt) {
      state.sysTreeOpt.only_policy_mng_yn = data ? 1 : 0
    }
  },
  setBluemaxModelType (state, bluemaxModelType) {
    const deviceModelParam = []
    const deviceModelTypes = _.map(bluemaxModelType.split(','), _.trim)

    if (!_.isEmpty(deviceModelTypes)) {
      _.forEach(deviceModelTypes, value => {
        // 장비 모델 타입 (미설정 NULL, 장비 모델 유형 9 MF2, 10 MFI, 11 MFD, 12 MF2 AE, 20 Bluemax NGF, 21 Bluemax IPS, 22 Bluemax WIPS)
        switch (value) {
          case 'ngf':
            deviceModelParam.push(20)
            break
          case 'ips':
            deviceModelParam.push(21)
            break
          case 'wips':
            deviceModelParam.push(22)
            break
          case 'mf2':
            deviceModelParam.push(9)
            break
          case 'mfi':
            deviceModelParam.push(10)
            break
          case 'mfd':
            deviceModelParam.push(11)
            break
          default:
            break
        }
      })
    }

    if (state.menuOpt) {
      // device_model_type이 있을 경우, tams_yn 설정이 적용 안되는 SQL문 보완.
      const deviceModelType = _.cloneDeep(deviceModelParam)
      if (!_.isEmpty(state.menuOpt.device_model_type) && state.menuOpt.tams_yn) {
        deviceModelType.push(0)
      }
      state.menuOpt.device_model_type = deviceModelType.length > 0 ? deviceModelType.join(',') : null // deviceModelType
    }

    if (state.sysTreeOpt) {
      // device_model_type이 있을 경우, tams_yn 설정이 적용 안되는 SQL문 보완.
      const deviceModelType = _.cloneDeep(deviceModelParam)
      if (!_.isEmpty(state.sysTreeOpt.device_model_type) && state.sysTreeOpt.tams_yn) {
        deviceModelType.push(0)
      }
      state.menuOpt.device_model_type = deviceModelType.length > 0 ? deviceModelType.join(',') : null // deviceModelType
    }
  },
  setDeviceSubType (state, type = false) {
    const deviceSubType = type ? 1 : 0

    if (state.menuOpt) {
      state.menuOpt.device_sub_type = deviceSubType
    }
    if (state.sysTreeOpt) {
      state.sysTreeOpt.device_sub_type = deviceSubType
    }
  },
  setMemoData (state, data) {
    state.deviceMemoList = []
    state.deviceMemoList = data
  },
  initSeletedMemo (state) {
    state.selectedMemo = initSelectedMemo()
  },
  initMemoList (state) {
    state.deviceMemoList = []
  },
  setSeletedMemo (state, item) {
    state.selectedMemo = _.cloneDeep(item)
  },
  // 장치 리스트 가져오기
  setDeviceTree (state, data) {
    state.deviceParent = JSON.parse(JSON.stringify(data))
    state.orgDeviceTreeData = []
    state.orgDeviceTreeData = state.deviceParent.filter((item) => {
      item.img = ''
      item.mode = ''
      item['btnLabel'] = ''
      // 모든 Node에 메모 버튼 추가
      if (state.memoUse === true) {
        item['mode'] = 'W' // '메모'
        item.img = 'ps-q-btn-tree-memo'
        item.btnLabel = 'cmn.memo'
      }

      // 장비 그룹만 리턴
      if (state.menuOpt.only_group_yn === 1 && (item.device_type === 0 || item.device_type === 4)) {
        return item
      // 모두 리턴
      } else if (state.menuOpt.only_group_yn === 0) {
        return item
      }
    })
    // Root Object 추출
    // const min = data[0]
    const min = data.filter((itm) => {
      return _.isNull(itm.parent_device_id)
    })[0]
    state.deviceDataAll = _.keyBy(_.filter(state.deviceParent, (items) => { return (items.device_type !== 0 && items.device_type !== 4) }), 'device_id')
    // _.setWith(min, 'level', 1)

    state.deviceTreeData = []
    state.deviceTreeData = deviceDataTreeConvert(state.orgDeviceTreeData, min.device_id, state.filterType, false)
    state.deviceExpanded = data.map(item => {
      return item.device_id
    })
  },
  // 장비 덮어쓰기 관련
  initOverwriteDevice (state) {
    state.overDeviceInfo.code = 0
    state.overDeviceInfo.msg = ''
    state.overDeviceInfo.addr = null
    state.overDeviceInfo.device_force_add_yn = 0
    state.overDeviceInfo.device_force_add_tams_type = 0
  },
  setOverwriteDevice (state, data) {
    const msg = JSON.parse(data.result.msg)
    state.overDeviceInfo.code = Number(data.code)
    state.overDeviceInfo.msg = msg.text
    state.overDeviceInfo.addr = _.has(msg, 'cfg_addr') ? msg.cfg_addr : {'mon1_addr': msg.mon1_addr, 'mon2_addr': msg.mon2_addr, 'mon3_addr': msg.mon3_addr}
  },
  setForceDevice (state) {
    state.overDeviceInfo.device_force_add_yn = 1
  }
}
export const actions = {
  // PAMS > 대상 방화벽 설정 추가 가능 장비 가져오기 / parent 값
  async firewallAddDevice ({commit}) {
    const result = {}
    result.error = null
    const url = '/api/pm/use-firewall/device'
    try {
      const data = await this.$axios.$get(url, {ignoreHaPrefix: true})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      result.data = data.result
      commit('setDeviceTree', result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 전체 장비 가져오기 / parent 값
  async getAllDevice ({commit, state}) {
    let params = {}

    if (!state.sysTreeUse) { // System Tree 미사용
      params = {
        only_group_yn: state.menuOpt.only_group_yn,
        only_config_yn: state.menuOpt.only_config_yn,
        tams_yn: state.menuOpt.tams_yn,
        slave_yn: state.menuOpt.slave_yn,
        tree_type: state.menuOpt.tree_type,
        event_code_yn: 1,
        device_model_type: state.menuOpt.device_model_type,
        device_sub_type: state.menuOpt.device_sub_type
      }

      if (_.has(state.menuOpt, 'except_mon_node_yn')) {
        params.except_mon_node_yn = state.menuOpt.except_mon_node_yn
      }
      if (_.has(state.menuOpt, 'only_policy_mng_yn')) {
        params.only_policy_mng_yn = state.menuOpt.only_policy_mng_yn
      }
      if (state.menuOpt.tree_type === 1) {
        if (_.has(state.menuOpt, 'menu_id')) {
          params.menu_id = state.menuOpt.menu_id
        }
        if (_.has(state.menuOpt, 'target_id_val')) {
          params.target_id_val = state.menuOpt.target_id_val
        }
      }
    } else { // System Tree 사용
      params = {
        only_group_yn: state.sysTreeOpt.only_group_yn,
        only_config_yn: state.sysTreeOpt.only_config_yn,
        tams_yn: state.sysTreeOpt.tams_yn,
        slave_yn: state.sysTreeOpt.slave_yn,
        tree_type: state.sysTreeOpt.tree_type,
        only_policy_mng_yn: state.menuOpt.only_policy_mng_yn,
        only_tams_yn: state.sysTreeOpt.only_tams_yn,
        event_code_yn: 1,
        device_model_type: state.sysTreeOpt.device_model_type,
        device_sub_type: state.sysTreeOpt.device_sub_type
      }

      if (_.has(state.sysTreeOpt, 'except_mon_node_yn')) {
        params.except_mon_node_yn = state.sysTreeOpt.except_mon_node_yn
      }
      if (_.has(state.sysTreeOpt, 'only_policy_mng_yn')) {
        params.only_policy_mng_yn = state.sysTreeOpt.only_policy_mng_yn
      }
    }

    /**
     * 지원 장비 적용 우선 순서
     * 1. param으로 설정된 device_model_type 값을 적용.
     * 2. menu에 설정된 support device_model_type 값을 적용(보류).
     */
    // 2. param 값을 적용 여부 확인 후 menu에서 support device 설정된 값을 적용.
    // TAMS 장비 미포함시 적용.
    // let modelType = this.getters['common/multirw/thisMenuSupportInfo'].device || null
    // if (!params.tams_yn && _.isEmpty(params.device_model_type) && !_.isEmpty(modelType)) {
    //   params.device_model_type = _.join(modelType)
    // }
    // console.log(params.device_model_type)

    const res = await this.$axios.$get(state.devicesTreeUrl, {
      params,
      ignoreHaPrefix: true,
      loading: false,
      loadingShow: false,
      loadingHide: false
    })

    if (res.code === 'ok') {
      commit('setDeviceTree', res.result)
    }
    return res
  },
  async addDevice ({commit, state}, payload = {data: void 0, loading: void 0, mon_node: false}) {
    const data = await this.$axios.$post(payload.mon_node ? `${state.devicesUrl}/mon-node` : state.devicesUrl, payload.data, _.merge(_.isUndefined(payload.loading) ? {loadingShow: true} : payload.loading, {ignoreHaPrefix: true}))
    if (data.code !== 'ok' && data.code !== 'nok' && [11020152, 11020153].includes(Number(data.code))) {
      return data
    }
    return data
  },
  async delDevice ({commit, state}, payload = {data: void 0}) {
    const res = await this.$axios.$delete(`${state.devicesUrl}/${payload.data.device_id}`, {ignoreHaPrefix: true})
    return res
  },
  // async moveDevice ({commit, dispatch, state}, payload) {
  async moveDevice ({commit, state}, payload) {
    const res = await this.$axios.$put(`${state.devicesUrl}/${payload.device_id}`, payload.param, {
      successAlert: false,
      ignoreHaPrefix: true,
      loadingHide: false
    })
    // dispatch('getAllDevice')
    return res
  },
  // 장비의 전체 메모 가져오기
  async getAllMemo ({commit, state}) {
    const res = await this.$axios.$get(`${state.devicesMemoUrl}/${state.device_id}/0`, {loadingShow: false, successAlert: false, ignoreHaPrefix: true})
    if (res.code === 'ok') {
      commit('setMemoData', res.result)
      commit('initSeletedMemo')
    }
    return res
  },
  // 장비의 선택한 메모 가져오기
  async getMemo ({state}, payload) {
    const {code, result} = await this.$axios.$get(`${state.devicesMemoUrl}/${payload.device_id}/${payload.device_memo_id}`, {ignoreHaPrefix: true})
    if (code === 'ok') {
      return result[0]
    }
    return result
  },
  async initMemo ({commit, state}) {
    const res = await this.$axios.$post(`${state.devicesMemoUrl}/init`, null, {loading: false, isNotAlert: true, ignoreHaPrefix: true})
    return res
  },
  async addMemo ({commit, state}, params) {
    const res = await this.$axios.$post(state.devicesMemoUrl, params, {loading: false, isNotAlert: true, ignoreHaPrefix: true})
    return res
  },
  async edtMemo ({commit, state}, params) {
    const res = await this.$axios.$put(state.devicesMemoUrl, params, {loading: false, isNotAlert: true, ignoreHaPrefix: true})
    return res
  },
  async delMemo ({commit, state}) {
    const res = await this.$axios.$put(`${state.devicesMemoUrl}/multi`, { device_memo_id_list: [state.selectedMemo.device_memo_id] }, {alertMsg: i18n.t('msg.removeApply'), ignoreHaPrefix: true})
    return res
  },
  async memoFinalCommand ({commit, state}, type) {
    const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    const res = await this.$axios.$put(`${state.devicesMemoUrl}/${type}`, void 0, _.merge(axiosConfig, {ignoreHaPrefix: true}))
    return res
  },
  // 신 Server -> NGF SSH 터널링 할당 후 자동 접속 방식
  async getDeviceConnectInfo ({state}, deviceId) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$get(`${apiPrefix}/devices/connect/port/${deviceId}`, {
        loading: false,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 구 client -> NGF 자동 접속 방식
  async getLoginDeviceInfo ({state}, id) {
    try {
      const res = await this.$axios.$get(`${state.devicesUrl}/${id}`, {loading: false, ignoreHaPrefix: true})
      return res
    } catch (e) {
      this.$log('[Error getLoginDeviceInfo]: ', e)
    }
  },
  async getLoginDeviceConnectCheck ({state}, {ip, port}) {
    try {
      const res = await this.$axios.$get(`/api/sm/devices/connect/${ip}/${port}`, {
        loading: false,
        ignoreHaPrefix: true
      })
      return res
    } catch (e) {
      this.$log('[Error getLoginDeviceConnectCheck]: ', e)
    }
  },
  // NGF GUI 연동용 일회성 key 요청
  async getLoginKey ({state}, {ip, port, clientId, clientSecret}) {
    let res = { code: 'ok', result: {} }
    try {
      const url = `https://${ip}${port}/api/au/external/login`
      const lang = this.getters['common/locale/getCurrentLocale']

      res = await this.$axios.$post(url, {
        ext_clnt_id: clientId,
        ext_clnt_secret: clientSecret,
        lang: lang,
        force: true,
        tams_login: 1
      }, {
        transformRequest: [(data, headers) => {
          delete headers.common['X-Gui-Menu']
          delete headers.common['Authorization']
          delete headers['X-Gui-Menu']
          delete headers['Authorization']
          headers['Content-Type'] = 'application/json;charset=utf-8'
          return JSON.stringify(data)
        }],
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
